var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChartIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6 4.7998H19.9999V10.3997H21.6V4.7998Z",
    fill: "#21334F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4001 2.3999H16.8V10.3998H18.4001V2.3999Z",
    fill: "#21334F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1999 7.2002H13.6001V10.4001H15.1999V7.2002Z",
    fill: "#21334F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.9999V2.3999C6.69818 2.3999 2.40002 6.69806 2.40002 11.9999C2.40002 17.3015 6.69818 21.5999 12 21.5999C17.3016 21.5999 21.6 17.3015 21.6 11.9999H12ZM10.3999 4.1603V12.4686L5.80946 17.0593C4.67978 15.6796 4.0001 13.9177 4.0001 11.9999C4.0001 8.13662 6.75314 4.9043 10.3999 4.1603ZM12 19.9998C10.0817 19.9998 8.32034 19.3201 6.94058 18.1905L11.5311 13.6H19.8389C19.0961 17.2468 15.8633 19.9998 12 19.9998Z",
    fill: "#21334F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartIcon);
export default __webpack_public_path__ + "static/media/chartIcon.1e9f17075f8410c354511f62af1e59cd.svg";
export { ForwardRef as ReactComponent };